import { Component, Input, forwardRef, OnDestroy, OnInit, Inject } from '@angular/core';

import { Subscription } from 'rxjs';

import { AbstractFormFieldComponent } from '../../../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { FooterFieldModel } from '../../../models/footer-field.model';
import { CurrentUserStateService } from '../../../../../Core/Users/services/current-user-state.service';
import { validateEmail } from '../../../../../Common/Misc/helpers/formatting/email.helper';
import { JournodexRegionsService } from '../../../../../Common/Journodex/services/journodex-regions.service';
import { DistributionErrors, DistributionService } from '../../../../../Common/TargetingShared/services/distribution.service';
import { AbstractPageBuilderService } from '../../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { messageSeverityEnum } from '../../../../../Common/Misc/enums/message-severity.enum';
import { ContactInfoTypesEnum } from '../../../../../Common/TargetingShared/enum/contact-info-types.enum';
import { DropdownOptionModel } from '../../../../../Common/Forms/models/dropdown-option.model';
import { FooterUnsubLanguagesEnum, footerUnsubLanguagesToUnsubString } from '../../../../../Common/TargetingShared/enum/footer-unsub-languages.emum';

@Component({
    selector: 'agpr-footer-field',
    templateUrl: './footer-field.component.html',
    styleUrls: ['./footer-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => FooterFieldComponent)
        }
    ],
    standalone: false
})
export class FooterFieldComponent extends AbstractFormFieldComponent implements OnInit, OnDestroy {
    readonly contactInfoTypesEnum = ContactInfoTypesEnum;
    readonly messageSeverityEnum = messageSeverityEnum;

    @Input() declare field: FooterFieldModel;

    userEmail: string = null;
    invalidEmail: boolean = false;
    contactInfoType: ContactInfoTypesEnum;
    countryLabel: string = 'name';
    errors: DistributionErrors;

    subscriptions: Subscription[] = [];

    unsubLanguageDropdownOptions: DropdownOptionModel[] = [];
    selectedUnsubLanguageOption: DropdownOptionModel;

    constructor(
        public currentUserStateService: CurrentUserStateService,
        @Inject(AbstractPageBuilderService) public distributionService: DistributionService,
        public journodexRegionsService: JournodexRegionsService
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.distributionService.getValidationErrors$().subscribe(errors => {
                if (errors) {
                    this.errors = errors;
                    this.invalidEmail = this.errors.footerHasInvalidEmail;
                }
            })
        );
        if (this.value.senderEmail) {
            this.contactInfoType = ContactInfoTypesEnum.email;
        } else if (this.value.senderPhone) {
            this.contactInfoType = ContactInfoTypesEnum.phone;
        }

        Object.values(FooterUnsubLanguagesEnum).forEach(item => {
            this.unsubLanguageDropdownOptions.push(new DropdownOptionModel(
                item + ' - ' + footerUnsubLanguagesToUnsubString.get(item),
                item
            ));
        });

        this.selectedUnsubLanguageOption = this.unsubLanguageDropdownOptions.find(option => option.value === this.value.unsubLinkLanguage);

        if (!this.selectedUnsubLanguageOption) {
            this.selectedUnsubLanguageOption = this.unsubLanguageDropdownOptions[0];
        }
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    emitChanges(error?: string) {
        if (this.errors) {
            this.errors[error] = false;
        }
        this.changes.emit((this.value).clone());
        this.distributionService.setFooter(this.value);
    }

    setContactInfoType(type: ContactInfoTypesEnum): void {
        this.contactInfoType = type;
        if (this.contactInfoType === ContactInfoTypesEnum.email) {
            this.value.senderPhone = null;
            this.value.senderEmail = this.userEmail;
        } else {
            this.value.senderEmail = null;
        }
        this.emitChanges('footerHasNoContact');
    }

    validateEmailFormat(): void {
        this.invalidEmail = !validateEmail(this.value.senderEmail);
    }

    onSelectUnsubLanguage(selectedItem: DropdownOptionModel): void {
        this.value.unsubLinkLanguage = selectedItem.value;
        this.emitChanges();
    }
}
